var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-container" },
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("首页")]),
              _c("el-breadcrumb-item", [_vm._v("供应系统")]),
              _c("el-breadcrumb-item", [_vm._v("基地管理")]),
              _c("el-breadcrumb-item", [_vm._v("基地养殖数据")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "hx-table-result",
        {
          attrs: { "page-info": _vm.pager, loading: _vm.tableLoading },
          on: {
            "page-current-change": _vm.handleCurrentChange,
            "page-size-change": _vm.handleSizeChange,
          },
        },
        [
          _c("div", { attrs: { slot: "action" }, slot: "action" }),
          _c("hx-table-result-col", [
            _c(
              "div",
              { staticClass: "wrap-table-info-display" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "align-left",
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.toCreate },
                  },
                  [_vm._v(" 新增 ")]
                ),
                _c("span", { staticClass: "table-info-display" }, [
                  _c("span", [_vm._v("总条数：")]),
                  _c("span", { staticClass: "alert-text ft16" }, [
                    _vm._v(_vm._s(_vm.pager.total)),
                  ]),
                ]),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              attrs: {
                slot: "content",
                data: _vm.tableData,
                "max-height": "800",
                border: "",
              },
              slot: "content",
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", width: "60", label: "序号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              (_vm.pager.pageIndex > 1
                                ? (_vm.pager.pageIndex - 1) * _vm.pager.pageSize
                                : 0) +
                                scope.$index +
                                1
                            ),
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "title", align: "center", label: "基地名称" },
              }),
              _c("el-table-column", {
                attrs: { prop: "address", align: "center", label: "品种" },
              }),
              _c("el-table-column", {
                attrs: { prop: "sort", align: "center", label: "品名" },
              }),
              _c(
                "el-table-column",
                { attrs: { prop: "sort", align: "center", label: "养殖规模" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "sort",
                      align: "center",
                      label: "生产期数量",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "sort", align: "center", label: "后备数量" },
                  }),
                ],
                1
              ),
              _c("el-table-column", {
                attrs: { prop: "sort", align: "center", label: "养殖面积" },
              }),
              _c("el-table-column", {
                attrs: { prop: "sort", align: "center", label: "供应开始时间" },
              }),
              _c("el-table-column", {
                attrs: { prop: "sort", align: "center", label: "供应次数" },
              }),
              _c("el-table-column", {
                attrs: { prop: "sort", align: "center", label: "次供应产量" },
              }),
              _c("el-table-column", {
                attrs: { prop: "sort", align: "center", label: "总产量" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }